import firebase from "firebase";

console.log(process.env);
const configOptions = {
    apiKey: process.env.VUE_APP_apiKey,
    authDomain: process.env.VUE_APP_authDomain,// "door42-test.firebaseapp.com",
    databaseURL: process.env.VUE_APP_databaseURL,// "https://door42-test.firebaseio.com",
    projectId: process.env.VUE_APP_projectId,// "door42-test",
    storageBucket: "",
    messagingSenderId: "",
    appId: ""
};

const app = firebase.initializeApp(configOptions);

export default app